var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAceptado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 416 419",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Number"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Container",
    cx: 208,
    cy: 209.5,
    rx: 204,
    ry: 203,
    fill: "#71cc98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Checkmark",
    d: "M161.1,284.2l-55.3-50.7,18.4-16.9,36.8,33.8,128.9-118.2,18.4,16.9-147.4,135.1h.2Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAceptado);
export default __webpack_public_path__ + "static/media/Aceptado.57da6867342b46bfb120493f7967bb25.svg";
export { ForwardRef as ReactComponent };